<template>
    <div>
        <DamagedHeader header="สินค้าชำรุดรอย้ายเข้าคลังรอคืน" :img_header="header_image" link_back="stock/storage/damagedstorage"/>
        <Damaged_product/>
    </div>
</template>

<script>
    import HeaderImage from '@/assets/pills_1.png'
    import DamagedHeader from "@/components/admin/stock/storage_damaged/header_damaged/DamagedHeader.vue";
    import Damaged_product from "@/components/admin/stock/storage_damaged/Damaged_product.vue";
    export default {
        name: "ProductDamage",
        components: {Damaged_product, DamagedHeader},
        data() {
            return {
                header_image: HeaderImage
            }
        }
    }
</script>

<style scoped>

</style>
